module.exports = __webpack_public_path__ + "1697301e8933269b22281bbcea87fbf4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-crazy.png
// module id = 2827
// module chunks = 0